import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Trash2 } from "lucide-react";
import { apiClient } from "../../lib/api";

export const DraftsList = ({ businessId, lang }) => {
  const [items, setItems] = useState(null);
  const ar = lang === "ar";
  const load = () => apiClient.get("/drafts", { params: businessId ? { business_id: businessId } : {} })
    .then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [businessId]);
  const remove = async (d) => {
    if (!window.confirm(ar ? "حذف هذه المسودة نهائياً؟" : "Delete this draft permanently?")) return;
    await apiClient.delete(`/drafts/${d.id}`).catch(() => {});
    localStorage.removeItem(`cartal_draft_${d.id}`);
    load();
  };
  if (!items || items.length === 0) return null;
  const fmt = (iso) => new Date(iso).toLocaleString(ar ? "ar-SA" : "en-GB", { dateStyle: "medium", timeStyle: "short" });
  return (
    <div className="mb-6 rounded-2xl border border-[#c9a55c]/40 bg-[#fbf8ee]/60 p-4" dir={ar ? "rtl" : "ltr"} data-testid="drafts-list">
      <div className="flex items-center gap-2 font-semibold mb-3">
        <FileText className="w-4 h-4 text-[#8a6f2e]" /> {ar ? "مسوداتي" : "My drafts"} <span className="text-xs text-[#8a8a8a]">({items.length})</span>
      </div>
      <div className="space-y-2">
        {items.map((d) => (
          <div key={d.id} className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-white px-3 py-2" data-testid={`draft-row-${d.id}`}>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{d.title || (ar ? "مسودة بدون عنوان" : "Untitled draft")}</div>
              <div className="text-[11px] text-[#8a8a8a]">
                {ar ? "آخر تعديل" : "Last edited"}: {fmt(d.updated_at)}{d.updated_by_name ? ` — ${d.updated_by_name}` : ""}
              </div>
            </div>
            <div className="flex gap-2">
              <Link to={`/sell?draft=${d.id}${d.business_id ? `&business_id=${d.business_id}` : ""}`}
                    className="rounded-full px-3 py-1 text-xs font-bold bg-[#c9a55c] text-[#0a0a0a]" data-testid={`draft-continue-${d.id}`}>
                {ar ? "متابعة" : "Continue"}
              </Link>
              <button type="button" onClick={() => remove(d)} className="rounded-full px-2 py-1 text-xs border border-[#d9d9d9]" data-testid={`draft-delete-${d.id}`}
                      aria-label={ar ? "حذف المسودة" : "Delete draft"}>
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
